import React from 'react';
import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultObjectiveResource,
    ObjectiveMutationResourceSchema,
    useObjectiveActions,
} from '../../../../../resource/resources/artifacts/objective/objectiveResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import {
    Form_DisplayComponentBaseView,
} from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { ObjectiveContent } from './ObjectiveContent';

export const ObjectiveEditDialog= ({ onClose, objectId, versionedInId }: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const objectiveActions = useObjectiveActions()
    const objectiveQuery = objectiveActions.useGetResourceByObjectIdAndVersionedIn(objectId, versionedInId);
    const updateObjective = objectiveActions.useUpdateResource();
    const validation = objectiveActions.useValidateResource(objectiveQuery.data?.id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: ObjectiveMutationResourceSchema,
        defaultValues: defaultObjectiveResource,
        submitHandler: async (data) => {
            await updateObjective.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: objectiveQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit Objective'}
            resourceType={ResourceType.OBJECTIVE}
            resourceValidationResult={validation.data}
            metaDataInfo={objectiveQuery.data}
        >
            <QueryBaseComponent name="Objective" query={objectiveQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <ObjectiveContent
                        form={form}
                        formNames={formNames}
                        readOnly={readOnly}
                        id={objectiveQuery.data?.id}
                    />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
